import { Routes } from '@angular/router';
import { RouteData } from './core/interfaces/route-data.interface';
import { AuthGuard } from './shared/guards/auth.guard';
import { UnverifiedOnlyGuard } from './shared/guards/unverified-only.guard';

export const routes: Routes = [
    {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        canActivate: [UnverifiedOnlyGuard],
        data: {
            priority: 'medium',
            preload: true
        } as RouteData,
        loadChildren: () => import('./authentication/authentication.routes').then(m => m.authenticationRoutes)
    },
    {
        path: 'about-us',
        data: {
            priority: 'low',
            preload: true
        } as RouteData,
        loadChildren: () => import('./about/about.routes').then(m => m.aboutRoutes)
    },
    {
        path: 'warranty',
        data: {
            priority: 'low',
            preload: true
        } as RouteData,
        loadChildren: () => import('./warranty-form/warranty-form.routes').then(m => m.warrantyFormRoutes)
    },
    {
        path: 'privacy-policy',
        loadChildren: () => import('./privacy-policy/privacy-policy.routes').then(m => m.privacyPolicyRoutes)
    },
    {
        path: 'shops',
        loadChildren: () => import('./shops/shops.routes').then(m => m.shopsRoutes)
    },
    {
        path: 'cart',
        canActivate: [AuthGuard],
        data: {
            title: 'Cart',
            footer: false,
            priority: 'critical',
            preload: true
        } as RouteData,
        loadChildren: () => import('./cart/cart.routes').then(m => m.cartRoutes)
    },
    {
        path: 'checkout/verify-payment',
        loadChildren: () => import('./checkout/components/verify-payment/verify-payment.routes').then(m => m.verifyPaymentRoutes),
        data: { navbar: false, footer: false, spacer: false }
    },
    {
        path: 'checkout',
        canActivate: [AuthGuard],
        loadChildren: () => import('./checkout/checkout.routes').then(m => m.checkoutRoutes),
        data: {
            navbar: false,
            footer: false,
            spacer: false,
            priority: 'critical',
            preload: true
        } as RouteData
    },
    {
        path: 'category/:url_path',
        data: {
            priority: 'high',
            preload: true
        } as RouteData,
        loadComponent: () => import('./category/components/category-layout/category-layout.component').then(m => m.CategoryLayoutComponent)
    },
    {
        path: 'search',
        loadComponent: () => import('./category/components/category-layout/category-layout.component').then(m => m.CategoryLayoutComponent)
    },
    {
        path: 'products',
        data: {
            priority: 'high',
            preload: true
        } as RouteData,
        // Direct loading for better performance - CategoryLayoutComponent handles products listing  pages
        loadComponent: () => import('./category/components/category-layout/category-layout.component').then(m => m.CategoryLayoutComponent)
        // OLD: loadChildren: () => import('./products/products.routes').then(m => m.productsRoutes)
    },
    {
        path: 'products/:id',
        data: {
            priority: 'high',
            preload: true
        } as RouteData,
        // Product detail route for individual products
        loadComponent: () => import('./products/components/product-detail-container/product-detail-container.component').then(m => m.ProductDetailContainerComponent)
    },
    {
        path: 'account',
        canActivate: [AuthGuard],
        loadChildren: () => {
            return import('./account/account.routes').then(m => {
                return m.accountRoutes;
            });
        },
    },
    {
        path: 'error',
        loadChildren: () => import('./core/components/error/error.routes').then(m => m.errorRoutes)
    },
    {
        path: 'maintenance',
        loadChildren: () => import('./core/components/error/error.routes').then(m => m.errorRoutes)
    },
    {
        path: 'unsubscribe',
        loadChildren: () => import('./core/components/error/error.routes').then(m => m.errorRoutes)
    },
    {
        path: '',
        loadChildren: () => import('./home/home.routes').then(m => m.homeRoutes)
    },
    {
        path: 'pages/homepage',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'pages/:page',
        loadChildren: () => import('./pages/pages.routes').then(m => m.pagesRoutes)
    },
    {
        path: '**',
        loadChildren: () => import('./core/components/error/error.routes').then(m => m.errorRoutes)
    }
];
